import React from 'react'
import {Routes as Router, Route, Navigate, Outlet} from 'react-router-dom'
import HomePage from './pages/home';
import EventsPage from './pages/events';
import EventDetailPage from './pages/events/[id]';
import AchievementsPage from './pages/achievements';
import CardsPage from './pages/cards';
import RankingPage from './pages/ranking';

type Props = {}



// const PrivateRoutes = () => {
//   const { authenticated } = useContext(AuthContext)
//   if(!authenticated) return <Navigate to='/login' replace />
//   return <Outlet />
// }

const NotFound = () => {
  return (
    <>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for could not be found.</p>
    </>
  );
};

const Routes = (props: Props) => {
  // const { authenticated } = useContext(AuthContext)

  return (
    <Router>
        {/* <Route path='/login' element={<LoginPage />}/> */}
        {/* <Route element={<PrivateRoutes />}> */}
          <Route path='/card/:hash' element={<HomePage />} />
          <Route path="/events/:hash" element={<EventsPage />} />
          <Route path="/events/:hash/:id" element={<EventDetailPage />} />
          <Route path="/achievements/:hash" element={<AchievementsPage />} />
          <Route path="/cards/:hash" element={<CardsPage />} />
          <Route path="/ranking" element={<RankingPage />} />
          {/* <Route path='/event/:type' element={<EventLandingPage />} />
          <Route path='/event/:type/:eventid/:fightid/:scriptlogid' element={<EventPage />} />
          <Route path='/cards/:userId' element={<CardsPage />} />
          <Route path='/compose' element={<ComposePage />} />
          <Route path='/user/:userId' element={<UserPage />} />
          <Route path='/lastestheros' element={<LastestHerosPage />} /> */}
        {/* </Route> */}
        {/* <Route path='/hong' element={<HongPage />} />
        <Route path='/wechatloginreturn' element={<WechatLoginReturn />} />
        <Route path='/dyloginreturn' element={<DyLoginReturn />} /> */}

        <Route path="*" element={<NotFound />} />

    </Router>
  )
}

export default Routes